export default "__VITE_ASSET__22e9c77d__"